import { Directive } from '@angular/core';

@Directive({
  selector: '[nttPrefix]',
})
export class NttPrefix {}
